const RTL_LANGS = ['ar'];
export const isLanguageRTL = (lng) => {
  return RTL_LANGS.indexOf(lng) !== -1;
};
